module.exports = __webpack_public_path__ + "img/light1.695c40de.png";